module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-293fe79b.png";